//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['à¤¥à¥à¤¡à¤¯à¤¾ à¤¸à¥à¤à¤à¤¡à¤¾à¤à¤¨à¥', 'à¤¥à¥à¤¡à¥ à¤¸à¥à¤à¤à¤¡'],
            ss: [number + ' à¤¸à¥à¤à¤à¤¡à¤¾à¤à¤¨à¥', number + ' à¤¸à¥à¤à¤à¤¡'],
            m: ['à¤à¤à¤¾ à¤®à¤¿à¤£à¤à¤¾à¤¨', 'à¤à¤ à¤®à¤¿à¤¨à¥à¤'],
            mm: [number + ' à¤®à¤¿à¤£à¤à¤¾à¤à¤¨à¥', number + ' à¤®à¤¿à¤£à¤à¤¾à¤'],
            h: ['à¤à¤à¤¾ à¤µà¤°à¤¾à¤¨', 'à¤à¤ à¤µà¤°'],
            hh: [number + ' à¤µà¤°à¤¾à¤à¤¨à¥', number + ' à¤µà¤°à¤¾à¤'],
            d: ['à¤à¤à¤¾ à¤¦à¤¿à¤¸à¤¾à¤¨', 'à¤à¤ à¤¦à¥à¤¸'],
            dd: [number + ' à¤¦à¤¿à¤¸à¤¾à¤à¤¨à¥', number + ' à¤¦à¥à¤¸'],
            M: ['à¤à¤à¤¾ à¤®à¥à¤¹à¤¯à¤¨à¥à¤¯à¤¾à¤¨', 'à¤à¤ à¤®à¥à¤¹à¤¯à¤¨à¥'],
            MM: [number + ' à¤®à¥à¤¹à¤¯à¤¨à¥à¤¯à¤¾à¤¨à¥', number + ' à¤®à¥à¤¹à¤¯à¤¨à¥'],
            y: ['à¤à¤à¤¾ à¤µà¤°à¥à¤¸à¤¾à¤¨', 'à¤à¤ à¤µà¤°à¥à¤¸'],
            yy: [number + ' à¤µà¤°à¥à¤¸à¤¾à¤à¤¨à¥', number + ' à¤µà¤°à¥à¤¸à¤¾à¤'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'à¤à¤¾à¤¨à¥à¤µà¤¾à¤°à¥_à¤«à¥à¤¬à¥à¤°à¥à¤µà¤¾à¤°à¥_à¤®à¤¾à¤°à¥à¤_à¤à¤ªà¥à¤°à¥à¤²_à¤®à¥_à¤à¥à¤¨_à¤à¥à¤²à¤¯_à¤à¤à¤¸à¥à¤_à¤¸à¤ªà¥à¤à¥à¤à¤¬à¤°_à¤à¤à¥à¤à¥à¤¬à¤°_à¤¨à¥à¤µà¥à¤¹à¥à¤à¤¬à¤°_à¤¡à¤¿à¤¸à¥à¤à¤¬à¤°'.split(
                    '_'
                ),
            format: 'à¤à¤¾à¤¨à¥à¤µà¤¾à¤°à¥à¤à¥à¤¯à¤¾_à¤«à¥à¤¬à¥à¤°à¥à¤µà¤¾à¤°à¥à¤à¥à¤¯à¤¾_à¤®à¤¾à¤°à¥à¤à¤¾à¤à¥à¤¯à¤¾_à¤à¤ªà¥à¤°à¥à¤²à¤¾à¤à¥à¤¯à¤¾_à¤®à¥à¤¯à¤¾à¤à¥à¤¯à¤¾_à¤à¥à¤¨à¤¾à¤à¥à¤¯à¤¾_à¤à¥à¤²à¤¯à¤¾à¤à¥à¤¯à¤¾_à¤à¤à¤¸à¥à¤à¤¾à¤à¥à¤¯à¤¾_à¤¸à¤ªà¥à¤à¥à¤à¤¬à¤°à¤¾à¤à¥à¤¯à¤¾_à¤à¤à¥à¤à¥à¤¬à¤°à¤¾à¤à¥à¤¯à¤¾_à¤¨à¥à¤µà¥à¤¹à¥à¤à¤¬à¤°à¤¾à¤à¥à¤¯à¤¾_à¤¡à¤¿à¤¸à¥à¤à¤¬à¤°à¤¾à¤à¥à¤¯à¤¾'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'à¤à¤¾à¤¨à¥._à¤«à¥à¤¬à¥à¤°à¥._à¤®à¤¾à¤°à¥à¤_à¤à¤ªà¥à¤°à¥._à¤®à¥_à¤à¥à¤¨_à¤à¥à¤²._à¤à¤._à¤¸à¤ªà¥à¤à¥à¤._à¤à¤à¥à¤à¥._à¤¨à¥à¤µà¥à¤¹à¥à¤._à¤¡à¤¿à¤¸à¥à¤.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'à¤à¤¯à¤¤à¤¾à¤°_à¤¸à¥à¤®à¤¾à¤°_à¤®à¤à¤à¤³à¤¾à¤°_à¤¬à¥à¤§à¤µà¤¾à¤°_à¤¬à¤¿à¤°à¥à¤¸à¥à¤¤à¤¾à¤°_à¤¸à¥à¤à¥à¤°à¤¾à¤°_à¤¶à¥à¤¨à¤µà¤¾à¤°'.split('_'),
        weekdaysShort: 'à¤à¤¯à¤¤._à¤¸à¥à¤®._à¤®à¤à¤à¤³._à¤¬à¥à¤§._à¤¬à¥à¤°à¥à¤¸à¥à¤¤._à¤¸à¥à¤à¥à¤°._à¤¶à¥à¤¨.'.split('_'),
        weekdaysMin: 'à¤_à¤¸à¥_à¤®à¤_à¤¬à¥_à¤¬à¥à¤°à¥_à¤¸à¥_à¤¶à¥'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [à¤µà¤¾à¤à¤¤à¤¾à¤]',
            LTS: 'A h:mm:ss [à¤µà¤¾à¤à¤¤à¤¾à¤]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [à¤µà¤¾à¤à¤¤à¤¾à¤]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [à¤µà¤¾à¤à¤¤à¤¾à¤]',
            llll: 'ddd, D MMM YYYY, A h:mm [à¤µà¤¾à¤à¤¤à¤¾à¤]',
        },
        calendar: {
            sameDay: '[à¤à¤¯à¤] LT',
            nextDay: '[à¤«à¤¾à¤²à¥à¤¯à¤¾à¤] LT',
            nextWeek: '[à¤«à¥à¤¡à¤²à¥] dddd[,] LT',
            lastDay: '[à¤à¤¾à¤²] LT',
            lastWeek: '[à¤«à¤¾à¤à¤²à¥] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s à¤à¤¦à¥à¤',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(à¤µà¥à¤°)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'à¤µà¥à¤°' only applies to day of the month
                case 'D':
                    return number + 'à¤µà¥à¤°';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /à¤°à¤¾à¤¤à¥|à¤¸à¤à¤¾à¤³à¥à¤|à¤¦à¤¨à¤ªà¤¾à¤°à¤¾à¤|à¤¸à¤¾à¤à¤à¥/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'à¤°à¤¾à¤¤à¥') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'à¤¸à¤à¤¾à¤³à¥à¤') {
                return hour;
            } else if (meridiem === 'à¤¦à¤¨à¤ªà¤¾à¤°à¤¾à¤') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'à¤¸à¤¾à¤à¤à¥') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'à¤°à¤¾à¤¤à¥';
            } else if (hour < 12) {
                return 'à¤¸à¤à¤¾à¤³à¥à¤';
            } else if (hour < 16) {
                return 'à¤¦à¤¨à¤ªà¤¾à¤°à¤¾à¤';
            } else if (hour < 20) {
                return 'à¤¸à¤¾à¤à¤à¥';
            } else {
                return 'à¤°à¤¾à¤¤à¥';
            }
        },
    });

    return gomDeva;

})));
